export function TableProductBody({
  rows,
  children,
}: {
  rows: (string | null)[][];
  children: (data: (string | null)[], index: number) => JSX.Element;
}) {
  return <>{rows.slice(1).map((item, index) => children(item, index))}</>;
}
